module.exports = __webpack_public_path__ + "img/IDA_Logo_2.7a9a7a2c.png";